'use client';

import { useState } from 'react';
import SearchMetrics from './SearchMetrics';
import BookingConversions from './BookingConversions';
import UserBehavior from './UserBehavior';
import RevenueAnalytics from './RevenueAnalytics';
import EmailReportExport from './EmailReportExport';
import Icon from '@/components/ui/AppIcon';

type TabType = 'searches' | 'bookings' | 'behavior' | 'revenue' | 'export';

const AnalyticsDashboardInteractive = () => {
  const [activeTab, setActiveTab] = useState<TabType>('searches');

  const tabs = [
    { id: 'searches' as TabType, label: 'Search Metrics', icon: 'MagnifyingGlassIcon' },
    { id: 'bookings' as TabType, label: 'Booking Conversions', icon: 'CheckCircleIcon' },
    { id: 'behavior' as TabType, label: 'User Behavior', icon: 'UserGroupIcon' },
    { id: 'revenue' as TabType, label: 'Revenue Analytics', icon: 'CurrencyPoundIcon' },
    { id: 'export' as TabType, label: 'Export Reports', icon: 'ArrowDownTrayIcon' },
  ];

  return (
    <div className="space-y-6">
      {/* Tab Navigation */}
      <div className="bg-card rounded-lg shadow-sm p-2 flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center space-x-2 px-4 py-3 rounded-lg font-medium transition-all duration-200 ${
              activeTab === tab.id
                ? 'bg-primary text-white shadow-md'
                : 'text-foreground hover:bg-surface'
            }`}
          >
            <Icon name={tab.icon as any} size={20} />
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="animate-fade-in">
        {activeTab === 'searches' && <SearchMetrics />}
        {activeTab === 'bookings' && <BookingConversions />}
        {activeTab === 'behavior' && <UserBehavior />}
        {activeTab === 'revenue' && <RevenueAnalytics />}
        {activeTab === 'export' && <EmailReportExport />}
      </div>
    </div>
  );
};

export default AnalyticsDashboardInteractive;